import { SnackbarProvider } from "notistack";
import { type ReactNode, useEffect } from "react";

import { showErrorToast } from "./showToast";
/**
 * FIXME - find a way to use notistack with css-in-js or styled components.
 * Tested `styled` function, and `sx` props
 */
// eslint-disable-next-line no-restricted-imports,
import classes from "./Snackbar.module.scss";
import { SnackbarToast } from "./Toast";

/**
 * sessionStorage key written by `handleCognitoSessionRevoked` before the
 * full-page redirect to /enter.  Must match the value used in
 * `cognitoSessionLogout.ts` — kept as a plain string here to avoid a
 * cross-boundary import that violates the `no-restricted-imports` rule.
 */
const DEFERRED_TOAST_KEY = "cognito_session_revoked_toast";

/**
 * On mount, checks sessionStorage for a deferred toast message stored before
 * a full-page redirect (e.g. after Cognito session revocation). If found,
 * shows it as an error toast and removes the key so it only fires once.
 */
function DeferredSessionToast() {
  useEffect(() => {
    const message = sessionStorage.getItem(DEFERRED_TOAST_KEY);
    if (message) {
      sessionStorage.removeItem(DEFERRED_TOAST_KEY);
      showErrorToast(message);
    }
  }, []);

  return null;
}

interface MuiSnackBarProviderProps {
  children: ReactNode;
}
export function MuiSnackBarProvider(props: MuiSnackBarProviderProps) {
  const { children } = props;
  return (
    <SnackbarProvider
      preventDuplicate
      classes={{
        /**
         * FIXME - find a way to use notistack with css-in-js or styled components.
         * Tested `styled` function, and `sx` props
         */
        containerAnchorOriginTopCenter: classes.SnackbarContainerRoot,
      }}
      Components={{
        default: SnackbarToast,
        error: SnackbarToast,
        info: SnackbarToast,
        warning: SnackbarToast,
        success: SnackbarToast,
      }}
      anchorOrigin={{ horizontal: "center", vertical: "top" }}
      autoHideDuration={5000}
      maxSnack={2}
    >
      <DeferredSessionToast />
      {children}
    </SnackbarProvider>
  );
}
